import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import highestOIGainersLosersReducer from "./highestOIGainersLosers";
import drivingMarketParamsReducer from "../drivingMarketParams";
export default combineReducers({
    reducersData: highestOIGainersLosersReducer,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
